var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};



// const loadMoreButton = document.getElementById('load-more-btn');

// loadMoreButton.addEventListener('click', function (event) {
//   console.log('shopify:section:load');
//   updatebutton
// });

setInterval(function () {
  // const container = document.querySelector('.search-grid-container')
  const containerButtons = document.querySelectorAll('.qmr-col-btn')

  if (localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) === null) {
    var wishlistArray = []
    const emptyWishlistP = document?.querySelector('.empty-wishlist')
    if (emptyWishlistP) {
      emptyWishlistP.innerText = 'Your Wishlist is currently empty.'
    }
  } else {
    var wishlistArray = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY).split(LOCAL_STORAGE_DELIMITER)
  }

  containerButtons.forEach(button => {
    if (wishlistArray.find(item => item === button.getAttribute('data-product-handle'))) {
      button.classList.add('active')
    } else {
      button.classList.remove('active')
    }
  })
}, 500);

document.addEventListener('shopify-wishlist:updated', function (event) {
  // console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
  // console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
  // document.getElementById('wishlist-count').innerHTML = event.detail.wishlist.length;
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
  // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
  if (document.getElementById('wishlist-count')?.innerHTML) {
  document.getElementById('wishlist-count').innerHTML = event.detail.wishlist.length;
}
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    console.log('productTileTemplateUrl', productTileTemplateUrl)
    return fetch(productTileTemplateUrl).then(function (res) {
      // console.log('productTileTemplateUrl res', res.text())
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    // replaceAll("\\[.*?\\]", "")
    wishlistProductCards = wishlistProductCards.replaceAll('<ul class="c-product-item__swatches">', '<ul class="c-product-item__swatches" style="display:none !important">')  
    console.log("wishlistProductCards", wishlistProductCards)
    
    grid.innerHTML = wishlistProductCards;
    // return 
    grid.classList.add(GRID_LOADED_CLASS);

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.removeEventListener('click', addProductHandle);
    button.addEventListener('click', addProductHandle);
  });
};

var addProductHandle = function (event) {
  console.log("addProductHandle triggered")
  var productHandle = event.target.closest('button').getAttribute('data-product-handle');
  updateWishlist(productHandle);
}

var updateButton = function (button) {
  button.removeEventListener('click', addProductHandle);
  button.addEventListener('click', addProductHandle);
  var productHandle = button.getAttribute('data-product-handle') || false;
  if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
  if (wishlistContains(productHandle)) {
    button.classList.add('active');
  } else {
    button.classList.remove('active');
  }
}

var initGrid = function () {
  console.log('initGrid()')
  var grid = document.querySelector(selectors.grid) || false;
  console.log('initGrid', grid)
  if (grid) setupGrid(grid);
};

var initButtons = function () {
  console.log("INIT BUTTONS")
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  console.log("setWishlist")
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  console.log("updateWishlist")
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

document.addEventListener('DOMContentLoaded', function () {
  initButtons();
  initGrid();
});